export default {"src":"/_next/static/media/hamburger.e6bd00a5.svg","height":22,"width":25};